<ngx-skeleton-loader *ngIf="isLoading$ | async" count="1" [theme]="{  height: '90px', width: '100%' }"> </ngx-skeleton-loader>
<div class="mb-4 text">
  <p class="text-size-22 fw-700">Welcome home!</p>
</div>
